import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Calendar, ArrowRight } from "lucide-react";
import api, { fileUrl } from "../lib/api";
import Seo from "../components/Seo";

export default function Blog() {
  const [cat, setCat] = useState("");
  const { data } = useQuery({ queryKey: ["blogs", cat], queryFn: async () => (await api.get("/blog", { params: cat ? { category: cat } : {} })).data });
  const items = data?.items || [];
  const cats = [...new Set(items.map((b) => b.category).filter(Boolean))];
  const featured = items[0];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <Seo title="Faridabad Property Guides & Market Updates" description="Local Faridabad property guides, sector insights and buying tips from our team." />
      <div className="mb-8">
        <h1 className="font-heading text-3xl sm:text-5xl font-extrabold text-slate-900">Faridabad Property Guides</h1>
        <p className="text-slate-500 mt-2 max-w-2xl">Local, useful guidance for buyers and investors — sector guides, price insights and buying tips.</p>
      </div>

      {items.length === 0 ? (
        <div className="text-center py-24 bg-slate-50 rounded-2xl border border-dashed border-slate-200 text-slate-500">No published articles yet. Check back soon.</div>
      ) : (
        <>
          {cats.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-8">
              <button onClick={() => setCat("")} className={`px-3 py-1.5 rounded-full text-sm border ${!cat ? "bg-indigo-900 text-white border-indigo-900" : "border-slate-200 text-slate-600"}`}>All</button>
              {cats.map((c) => <button key={c} onClick={() => setCat(c)} className={`px-3 py-1.5 rounded-full text-sm border ${cat === c ? "bg-indigo-900 text-white border-indigo-900" : "border-slate-200 text-slate-600"}`}>{c}</button>)}
            </div>
          )}
          <div className="grid lg:grid-cols-3 gap-6">
            {items.map((b) => (
              <Link key={b.id} to={`/blog/${b.slug}`} data-testid={`blog-card-${b.slug}`} className="group rounded-2xl overflow-hidden border border-slate-200 bg-white hover:shadow-xl transition-all flex flex-col">
                <div className="aspect-[16/9] overflow-hidden bg-slate-100">
                  {b.featured_image ? <img src={fileUrl(b.featured_image)} alt={b.image_alt || b.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /> : <div className="w-full h-full bg-indigo-50 flex items-center justify-center text-indigo-800 font-heading font-bold">Faridabad Property</div>}
                </div>
                <div className="p-5 flex flex-col flex-1">
                  {b.category && <span className="text-xs font-semibold text-indigo-800">{b.category}</span>}
                  <h3 className="font-heading font-bold text-lg text-slate-900 mt-1 group-hover:text-indigo-800 line-clamp-2">{b.title}</h3>
                  <p className="text-sm text-slate-500 mt-2 line-clamp-2 flex-1">{b.excerpt}</p>
                  <div className="mt-3 text-sm font-semibold text-indigo-800 flex items-center gap-1 group-hover:gap-2 transition-all">Read <ArrowRight className="w-4 h-4" /></div>
                </div>
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
